// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__0UFtj","input":"styles_input__ql09Z"};